import { render, staticRenderFns } from "./Result.Grid.vue?vue&type=template&id=62d96ae0&"
import script from "./Result.Grid.vue?vue&type=script&lang=js&"
export * from "./Result.Grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports